interface ListenerFn<T = any> {
  (...args: Array<T>): void;
}
class EventEmitter {
  private events: Record<string | symbol, Array<ListenerFn> | ListenerFn> = {};

  public on(event: string | symbol, fn: ListenerFn, context?: unknown): this {
    if (!this.events[event]) {
      this.events[event] = fn;
    } else if (this.events[event] && !Array.isArray(this.events[event])) {
      this.events[event] = [this.events[event] as ListenerFn, fn];
    } else {
      (this.events[event] as Array<ListenerFn>).push(fn);
    }

    return this;
  }

  public once(event: string, fn: ListenerFn, context?: unknown): this {
    const once = (...args: Array<unknown>): void => {
      this.off(event, once);
      fn(...args);
    };

    return this.on(event, once, context);
  }

  public off(event: string | symbol, fn?: ListenerFn | undefined, context?: unknown, once?: boolean | undefined): this {
    if (fn) {
      if (Array.isArray(this.events[event])) {
        const eventIndex = (this.events?.[event] as Array<ListenerFn>).indexOf(fn);

        if (eventIndex >= 0) {
          (this.events[event] as Array<ListenerFn>).splice(eventIndex, 1);
        }
      } else if (this.events?.[event] === fn) {
        delete this.events[event];
      }
    } else {
      delete this.events[event];
    }

    return this;
  }

  public emit(event: string, ...args: Array<unknown>): void {
    if (Array.isArray(this.events[event])) {
      for (const fn of this.events?.[event] as Array<ListenerFn>) {
        fn(...args);
      }
    } else if (this.events?.[event]) {
      (this.events[event] as ListenerFn)(...args);
    }
  }

  public destroy(): void {
    this.events = {};
  }
}

export default EventEmitter;
